import { render, staticRenderFns } from "./face-control.vue?vue&type=template&id=650ffe2f&"
import script from "./face-control.vue?vue&type=script&lang=ts&"
export * from "./face-control.vue?vue&type=script&lang=ts&"
import style0 from "./face-control.vue?vue&type=style&index=0&id=650ffe2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports